export default [
    {
        method: 'getCountryList',
        type: 'GET',
        path: '/web/common/countryList',
        mode: 'passport',
        params: [],
        options: { cache: false, },
        switch: false,
        // desc: '地区码列表'
    },
    {
        method: 'getUserInfo',
        type: 'GET',
        path: '/web/user/info',
        mode: 'passport',
        params: ["ct"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '查询登录态'
    },
    {
        method: 'logOut',
        type: 'POST',
        path: '/web/user/logout',
        mode: 'passport',
        params: ["changeBaseUrl"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: '日本平台登出接口'
    },
    {
        method: 'getJpUserInfo',
        type: 'GET',
        path: '/web/user/info',
        mode: 'passport',
        params: ["ct"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: '日本平台查询登录态'
    },
    {
        method: 'getCaptchaCode',
        type: 'POST',
        path: '/web/captcha/img/captcha',
        mode: 'passport',
        params: ["distribution_region", "changeBaseUrl"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: 'komoe东南亚邮箱账号获取图形验证码'
    },
    {
        method: 'verifyEmailCaptcha',
        type: 'POST',
        path: '/web/captcha/verify/captcha',
        mode: 'passport',
        params: ["img_token", "captcha"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: 'komoe东南亚邮箱账号修改密码，图形验证码'
    },
    {
        method: 'sendEmailLink',
        type: 'POST',
        path: '/web/email/gk/mail.send',
        mode: 'passport',
        params: ["email", "email_type", "pwd", "captcha", "img_token", "distribution_region", "changeBaseUrl"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: '邮箱发送确认链接'
    },
    {
        method: 'getOauth',
        type: 'GET',
        path: '/web/login/oauth/cookie',
        mode: 'passport',
        params: [],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: '查询是否第三方账号登陆'
    },
];